import React from 'react';
import {CircularProgress} from '@material-ui/core';
import {Box} from '@material-ui/core'

export const loader = <Box sx={{ display: 'flex', justifyContent: 'center' }}><CircularProgress /></Box>